import React from 'react';
import { Phone } from 'lucide-react';

const SixDaysSafari = () => {
  const itinerary = [
    {
      day: "Day 1: Arrival in Arusha",
      desc: "Upon arrival at the Airport, where your driver guide shall be waiting to warmly receive and welcome you to this beautiful country Tanzania. After a brief orientation with the driver guide, you will head to your accommodation in Arusha for relaxation and overnight stay before embarking on your safari the next day.",
      lodge: "Gran Melia Arusha",
    },
    {
      day: "Day 2: Transfer to Tarangire National Park",
      desc: "After your breakfast at the hotel, you will begin your park adventure with a pickup from your hotel and embark on your adventurous journey to Tarangire National Park, famous for its baobab trees and abundant wildlife including large elephant herds. Later, drive to your lodge for dinner and overnight stay.",
      lodge: "Kubu Kubu Tented Lodge",
    },
    {
      day: "Day 3: Transfer to Serengeti National Park",
      desc: "After breakfast, we will embark on our discovery journey to Serengeti National Park, traveling through the picturesque highlands of Ngorongoro Conservation Area. Serengeti is renowned for its annual migration, during which hundreds of thousands of wildebeests and zebras cross in search of fresh grass and water.",
      lodge: "Kubu Kubu Tented Lodge",
    },
    {
      day: "Day 4: Full Day in Serengeti National Park",
      desc: "You will wake up early and enjoy a full breakfast before starting our full day of game drives in the Serengeti. Depending on the time of year, you may witness the Great Migration, where millions of wildebeest and zebras traverse the plains in search of fresh grazing grounds.",
      lodge: "Kubu Kubu Tented Lodge",
    },
    {
      day: "Day 5: Serengeti to Ngorongoro Crater",
      desc: "Early in the morning after your breakfast, you will embark on your final morning game drive in the Serengeti. Later in the afternoon, transfer to the Ngorongoro Conservation Area. Upon reaching the edge of the Ngorongoro Crater you will be greeted by the stunning view of the giant caldera.",
      lodge: "Kitela Lodge",
    },
    {
      day: "Day 6: Ngorongoro Crater and Departure",
      desc: "After your morning breakfast, you will start your final day with a morning game drive in the Ngorongoro Crater, witnessing the vibrant wildlife including the Big Five. After an adventurous game watching experience, begin your journey back to Arusha or Kilimanjaro National Park for onward flight.",
      lodge: null,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white text-[#2f4f2f] py-4 px-6 border-b border-[#9acd32]/20">
        <h1 className="text-2xl font-bold">6 DAYS TANZANIA WILDLIFE SAFARI</h1>
      </header>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold text-[#2f4f2f] mb-6">
          6 Days Tanzania Wildlife Safari - Best Adventure Tanzania Tour
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Main Content - Left Side */}
          <div className="md:col-span-2">
            {/* Intro */}
            <div className="mb-8">
              <p className="text-gray-700 leading-relaxed mb-4">
                This <strong>6 Days Tanzania Wildlife Safari</strong> takes you deep into
                the heart of some of Africa’s most renowned national parks that is the
                Tarangire National Park, Serengeti National Park and Ngorongoro Crater.
                During the adventure, you will encounter vast numbers of diverse
                wildlife and the breathtaking landscapes of Tanzania.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                Tarangire National Park is commonly known for its giant baobab trees and
                large herds of elephant. Serengeti National Park is famous for its
                annual <strong>wildebeest migration</strong> and diverse wildlife like
                lions, cheetahs, and leopards and Ngorongoro Crater a UNESCO World
                Heritage Site is known for its stunning caldera and dense wildlife
                population including the Big Five.
              </p>
            </div>

            {/* Placeholder for Leopard Image */}
            <div className="mb-8">
              <div className="bg-[#f5f5f5] h-64 rounded-lg flex items-center justify-center text-gray-500 text-sm">
              
                 <img src="/leopardhunt.JPG" alt="6 days" className="w-full h-48 object-cover"/>
              </div>
              
            </div>

            {/* Itinerary */}
            <h3 className="text-2xl font-bold text-[#2f4f2f] mb-6">
              Itinerary for the 6 Days Tanzania Wildlife Safari
            </h3>

            {itinerary.map((item, index) => (
              <div key={index} className="mb-6 p-4 border border-[#9acd32]/20 rounded-lg">
                <h4 className="text-lg font-bold text-[#2f4f2f] mb-2">{item.day}</h4>
                <p className="text-gray-700 leading-relaxed mb-2">{item.desc}</p>
                {item.lodge && (
                  <p className="text-sm font-semibold text-[#2f4f2f]">
                    Accommodation: <span className="text-gray-700">{item.lodge}</span>
                  </p>
                )}
              </div>
            ))}

            {/* Inclusions & Exclusions */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
              <div>
                <h3 className="text-lg font-bold text-[#2f4f2f] mb-2">Inclusions</h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Transportation on a 4 x 4 safari vehicle with a pop-up roof
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Accommodations and meals as stated
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Entrance fees to all National Parks
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Game drives as mentioned
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Drinking water
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#9acd32] mr-2">•</span>
                    Professional English-speaking driver guide
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-bold text-[#2f4f2f] mb-2">Exclusions</h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  <li className="flex items-start">
                    <span className="text-[#228b22] mr-2">•</span>
                    Visa Fees & flights
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#228b22] mr-2">•</span>
                    Optional activities
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#228b22] mr-2">•</span>
                    Tips for guides
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#228b22] mr-2">•</span>
                    Alcoholic drinks
                  </li>
                  <li className="flex items-start">
                    <span className="text-[#228b22] mr-2">•</span>
                    International insurances & items of personal nature
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="md:col-span-1">
            <div className="sticky top-6">
              <div className="bg-white border border-[#9acd32]/20 rounded-lg p-4 mb-6">
                <h3 className="text-lg font-bold text-[#2f4f2f] mb-2">6 Days Tanzania Wildlife Safari</h3>
                <ul className="text-sm text-gray-700 mb-4 space-y-2">
                  <li>6 Days, 5 Nights safari</li>
                  <li>Destinations: Tarangire, Serengeti, Ngorongoro</li>
                  <li>Hotel pickup – Arusha</li>
                  <li>Hotel drop – Arusha</li>
                </ul>
                <button className="w-full bg-[#2f4f2f] hover:bg-[#228b22] text-white font-semibold py-3 px-4 rounded-lg mb-4 transition-colors">
                  Plan Your Trip Now
                </button>
                <div className="text-center">
                  <p className="text-sm text-gray-600 mb-2">Call/WhatsApp for a Free Quote</p>
                  <p className="text-lg font-bold text-[#2f4f2f]">
                    <Phone className="inline mr-2" size={20} />
                    <a href="tel:+255753182737" className="text-[#9acd32] hover:text-[#228b22] transition-colors">+255 753 182 737</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SixDaysSafari;